import React, { useContext } from 'react';
import { useTheme } from '@mui/material/styles';
import { IconProps } from './iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconSearch({
  extColor,
  isAutoscallable = true,
  sizeKey = '24x24',
  onClick,
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.primary.main;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 16 17"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.53809 2.51443C5.74739 2.61063 5.09512 2.83587 4.39123 3.25586C3.74365 3.64065 3.14065 4.24365 2.75586 4.89123C2.39453 5.49657 2.1904 6.02918 2.06605 6.68615C2.00504 7.00759 1.97923 7.84522 2.01912 8.16666C2.13878 9.09814 2.49307 9.96862 3.05384 10.7124C3.24389 10.9634 3.7108 11.4304 3.95951 11.6157C4.65401 12.1366 5.50103 12.4932 6.35039 12.6246C6.66245 12.6716 7.36634 12.6786 7.71124 12.6364C8.42686 12.5495 9.15421 12.2938 9.75252 11.9184L9.96134 11.787L11.2518 13.0775C12.7558 14.5767 12.6549 14.4993 13.0843 14.4993C13.3212 14.4993 13.3541 14.4946 13.4784 14.4313C13.6591 14.3445 13.8562 14.1497 13.936 13.9784C13.9923 13.8564 13.9993 13.8165 13.9993 13.5843C13.9993 13.1525 14.0767 13.2558 12.5775 11.7518L11.287 10.4613L11.4184 10.2525C12.0378 9.26473 12.2889 8.04231 12.1199 6.83866C12.005 6.02918 11.6366 5.15402 11.1157 4.45951C10.9304 4.2108 10.4634 3.74389 10.2124 3.55384C9.49208 3.01184 8.64507 2.65755 7.75817 2.5332C7.54465 2.5027 6.73518 2.48862 6.53809 2.51443ZM7.65493 4.41024C8.25089 4.50878 8.814 4.79972 9.28795 5.25021C9.67509 5.62093 9.94961 6.02684 10.1092 6.46794C10.4118 7.31026 10.3532 8.2699 9.94961 9.04183C9.64225 9.62841 9.11198 10.1587 8.52775 10.4566C7.76051 10.8532 6.80322 10.9095 5.96794 10.6092C5.09747 10.2948 4.31146 9.48293 4.02051 8.59838C3.84454 8.06108 3.81639 7.41819 3.94543 6.83866C4.14487 5.94706 4.81591 5.10709 5.66762 4.68476C6.26592 4.38912 6.94869 4.29527 7.65493 4.41024Z" />
    </svg>
  );
}
